const colors = {
  brand: "#f8b133",
  danger: "#D72C0D",
  primary: "#202223",
  secondary: "#6D7175",
  tertiary: "#5C5F62",
  focus: "#458FFF",

  default: {
    background: "#F6F6F7",
    stroke: "#BABFC3",
    color: "#5C5F62",
  },
  success: {
    background: "#F1F8F5",
    stroke: "#95C9B4",
    color: "#007F5F",
  },
  critical: {
    background: "#FFF4F4",
    stroke: "#E0B3B2",
    color: "#D72C0D",
  },
  informational: {
    background: "#EBF9FC",
    stroke: "#98C6CD",
    color: "#00A0AC",
  },
  warning: {
    background: "#FFF5EA",
    stroke: "#E1B878",
    color: "#B98900",
  },
  disabled: {
    background: "#FAFBFB",
    color: "#8C9196",
    stroke: "#D2D5D8",
  },
  interactive: {
    background: "rgba(46, 114, 210, 0.08)",
    color: "rgba(46, 114, 210, 1)",
    stroke: "rgba(46, 114, 210, 1)",
  },
};

export default colors;
